<template>
  <div class="search-standard-control">
    <input
      type="text"
      class="search-input"
      :placeholder="placeholder"
      :value="search"
      @input="$emit('input', $event.target.value.toLowerCase())">
    <i class="n-i n-i-search search-icon" />
  </div>
</template>

<script>
import translate from '@/filters/translate';

export default {
  name: 'SearchStandard',
  model: {
    prop: 'search',
    event: 'input',
  },
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  computed: {
    placeholder() {
      return `${translate('general.search')}...`;
    },
  },
};
</script>

<style lang="scss">
.search-standard-control {
  display: flex;
  align-items: center;
  color: #5f6874;
  background-color: #e8ecee;
  border: 1px solid #ccc;
  border-radius: 2px;
  overflow: hidden;
}

.search-standard-control > .search-input {
  height: 24px;
  margin: 0;
  padding: 0 8px;
  color: #5f6874;
  background-color: #e8ecee;
  border: 0;
  outline: 0;
  width: 150px;
}

.search-standard-control > .search-icon {
  padding: 0 4px;
}
</style>
